// extracted by mini-css-extract-plugin
module.exports = {"filters":"Filters-module__filters___6SSJR","filter":"Filters-module__filter___1YIl- Fonts-module__bt___102gf","ege":"Filters-module__ege___1q4NG Fonts-module__bt___102gf"};